import "../input-ctrl.scss";

function CheckBox(props) {
  const {
    name,
    value,
    checked,
    placeholder,
    onChange,
    disabled,
    classNames,
    title
  } = props;

  return (
    <label className={`check-box-ctrl ${classNames} ${disabled ? 'disabled' : ''}`}
      title={title}
    >{placeholder}
      <input
        name={name}
        type="checkbox"
        checked={checked}
        onChange={onChange ? (e) => onChange(e) : null}
        value={value}
        disabled={disabled}
      />
      <span className="checkmark"></span>
    </label>
  )
}

export default CheckBox